export enum MoodTypes {
  SAD = 1,
  TIRED,
  ANGRY,
  HAPPY,
  WORRIED,
  RELAXED,
}
